/**
 * entry.js
 * 
 * This is the first file loaded. It sets up the Renderer, 
 * Scene and Camera. It also starts the render loop and 
 * handles window resizes.
 * 
 */

import { WebGLRenderer, PerspectiveCamera, Scene, Vector3, Raycaster, Color, AxesHelper } from 'three';
import Stats from "three/examples/jsm/libs/stats.module.js";
import SeedScene from './objects/Scene.js';
var THREE = require('three');
var OrbitControls = require('three-orbit-controls')(THREE);
import { setupDatGUI } from "./guidat.js";
//import { setupUIGUI, mainPuzzleInfo } from "./uigui.js";
import { exportToJsonFile } from "./puzzle_exporter.js";
import {v4 as uuidv4} from 'uuid';
import * as dat from 'dat.gui';
import { UITabbedPanel, UISpan, UIPanel, UIText, UIRow, UIInput, UIHorizontalRule,
  UISelect, UINumber, UIInteger, UIButton, UIBreak, UIColor, UICheckbox } from './lib/ui.js';

const scene = new Scene();
const camera = new PerspectiveCamera();
const renderer = new WebGLRenderer({antialias: true});
const seedScene = new SeedScene();

var controls = new OrbitControls(camera, renderer.domElement);


// GUI Variables
var mainPuzzleInfo = {
    authorName : "",
    puzzleName : "",
    difficulty : "easy",
    puzzle_pieces_mode: "Puzzle"
}

var puzzleCreationControls = {
    hideMode : false,
    extensionLength: 1
}

var piecesCreationControls = {
    clearColorMode : false,
    ccolor: [200, 75, 75]
}

var colorPresets = {
    red : [200, 75, 75],
    blue : [75, 100, 200],
    green : [140, 200, 80],
    yellow : [230, 190, 80],
    purple : [100, 80, 200],
    pink : [200, 80, 160],
    orange : [200, 110, 70]
}

// Listener to read and load an existing puzzle
function readSingleFile(e) {
    var file = e.target.files[0];
    if (!file) {
        return;
    }
    var reader = new FileReader();
    reader.onload = function(e) {
        var contents = e.target.result;
        var jsonContents = JSON.parse(contents);
        // Call the puzzle creator function
        seedScene.createPuzzleFromFile(jsonContents);
    };
    reader.readAsText(file);
}

document.getElementById('puzzleInput')
.addEventListener('change', readSingleFile, false);

function setupUIGUI(){

  // Puzzle Mode Container
  var puzzle_mode_container = new UISpan();
  var puzzle_mode_panel = new UIPanel();
  puzzle_mode_panel.setBorderTop('0');
  puzzle_mode_panel.setPaddingTop('20px');
  puzzle_mode_container.add(puzzle_mode_panel);

  // Cube start position

  var cubeStartPositionRow = new UIRow();
  var objectPositionX = new UIInteger().setWidth( '50px' ).onChange( update );
  var objectPositionY = new UIInteger().setWidth( '50px' ).onChange( update );
  var objectPositionZ = new UIInteger().setWidth( '50px' ).onChange( update );

  cubeStartPositionRow.add( new UIText("Cube Position").setWidth( '120px' ) );
  cubeStartPositionRow.add( objectPositionX, objectPositionY, objectPositionZ );
  var cubeManualAddButton = new UIButton("Add");
  cubeStartPositionRow.add(cubeManualAddButton);
  cubeManualAddButton.onClick( function() {
    seedScene.addNewCube(objectPositionX.value, objectPositionY.value, objectPositionZ.value);
  });
  puzzle_mode_panel.add( cubeStartPositionRow );

  // Extrusion length

  var extensionLengthRow = new UIRow();
  var extensionLength = new UIInteger(1).setWidth( '50px' );
  extensionLengthRow.add( new UIText( "Extension Length" ).setWidth( '120px' ));
  extensionLengthRow.add( extensionLength );
  extensionLength.onChange( function() {
    puzzleCreationControls["extensionLength"] = extensionLength.value;
  });
  puzzle_mode_panel.add( extensionLengthRow );

  var hideShowRow = new UIRow();
  puzzle_mode_panel.add(hideShowRow);
  var hideShowToggle = new UICheckbox();
  hideShowToggle.setWidth( ' 40px ');
  hideShowToggle.setValue(false);
  hideShowToggle.onChange( function() {
    puzzleCreationControls["hideMode"] = hideShowToggle.getValue();
  });
  var showAllPiecesButton = new UIButton("Show All");
  showAllPiecesButton.onClick( function(){
    seedScene.scene_cubes.forEach(element => {
        element.visible = true;
    });
    hideShowToggle.setValue(false);
    puzzleCreationControls["hideMode"] = hideShowToggle.getValue();
  });
  hideShowRow.add(new UIText( "Hide Pieces" ).setWidth( '120px' ))
  hideShowRow.add(hideShowToggle, showAllPiecesButton, new UIHorizontalRule());

  // Buttons for Clear Colors, Clear Pieces and Load Cube File

  var clearPiecesRow = new UIRow();
  puzzle_mode_panel.add( clearPiecesRow );
  var clearPiecesBreak = new UIBreak();

  var loadCubeFileRow = new UIRow();
  puzzle_mode_panel.add( loadCubeFileRow );
  var loadCubeFileBreak = new UIBreak();

  var clearPieces = new UIButton( 'Clear Pieces' );
  clearPieces.onClick( function() {
    console.log("Preparing clear....");
    //Remove the added cubes
    seedScene.scene_cubes.forEach(scene_cube => {
      seedScene.remove(scene_cube);
    });
    seedScene.scene_cubes = [];
    seedScene.filled_cube_coordinates = [];
    seedScene.cube_pieces = {};
  });
  var loadCubeFile = new UIButton( 'Load Cube File');
  loadCubeFile.onClick( function(){
    document.getElementById('puzzleInput').click();
  });
  clearPiecesRow.add( clearPieces, clearPiecesBreak);
  //loadCubeFileRow.add( loadCubeFile, loadCubeFileBreak );


  // Update function for all puzzle mode related updates
  function update(){

  }

  // Pieces Mode Container
  var pieces_mode_container = new UISpan();
  var pieces_mode_panel = new UIPanel();
  pieces_mode_panel.setBorderTop('0');
  pieces_mode_panel.setPaddingTop('20px');
  pieces_mode_container.add(pieces_mode_panel);

  // Pick color

  var pieceColorRow = new UIRow();
  var pieceColor = new UIColor().onInput( function(){
    var color = new Color(pieceColor.getHexValue());
    piecesCreationControls["ccolor"] = [color.r*255., color.g*255., color.b*255.];
  } );
  var defaultColor = new Color(colorPresets["red"][0]/255., colorPresets["red"][1]/255., colorPresets["red"][2]/255.);
  pieceColor.setHexValue(defaultColor.getHex());
  pieceColorRow.add( new UIText( "Pick Piece Color" ).setWidth( '120px' ) );
  pieceColorRow.add( pieceColor, new UIBreak(), new UIBreak() );

  pieces_mode_panel.add( pieceColorRow );

  // Color Presets

  var colorPresetsRow = new UIRow();
  pieces_mode_panel.add( colorPresetsRow );

  colorPresetsRow.add( new UIText( "Color Presets" ).setWidth( '120px' ) );

  var colorPresetSelect = new UISelect().setOptions( {
    0: 'red',
    1: 'blue',
    2: 'green',
    3: 'yellow',
    4: 'purple',
    5: 'pink',
    6: 'orange'
  }).setWidth( '120px' ).onChange( updateColorPreset );

  function updateColorPreset(){
      // Update color preset here
      var preset = Object.keys(colorPresets)[colorPresetSelect.getValue()];
      var pColor = new Color(colorPresets[preset][0]/255., colorPresets[preset][1]/255., colorPresets[preset][2]/255.);
      pieceColor.setHexValue(pColor.getHex());
      piecesCreationControls["ccolor"] = [colorPresets[preset][0], colorPresets[preset][1], colorPresets[preset][2]];
  }
  colorPresetSelect.setValue( 0 );
  colorPresetsRow.add( colorPresetSelect );

  var clearColorsRow = new UIRow();
  pieces_mode_panel.add( clearColorsRow );
  var clearColorsBreak = new UIBreak();

  var clearColors = new UIButton( 'Clear Colors' );
  clearColors.onClick( function() {
    seedScene.clearPiecesColor();
  });
  clearColorsRow.add( new UIBreak(), clearColors, clearColorsBreak);


  // Export settings container
  var settings_container = new UISpan();
  var settings = new UIPanel();
  settings.setBorderTop( '0' );
  settings.setPaddingTop( '20px' );
  settings_container.add( settings );

  // Author Name

  var authorNameRow = new UIRow();
  var authorName = new UIInput( "author-name" ).setLeft( '100px' ).setWidth( '150px' ).onChange( function () {
      // Store the name of the author here
      console.log("Author name change", authorName.getValue());
      mainPuzzleInfo["authorName"] = authorName.getValue();
  } );

  authorNameRow.add( new UIText( "Author Name" ).setWidth( '90px' ) );
  authorNameRow.add( authorName );

  settings.add( authorNameRow );

  // Puzzle Name

  var puzzleNameRow = new UIRow();
  var puzzleName = new UIInput( "puzzle-name" ).setLeft( '100px' ).setWidth( '150px' ).onChange( function () {
      // Store the name of the puzzle here
      console.log("Puzzle name change");
      mainPuzzleInfo["puzzleName"] = puzzleName.getValue();
  } );

  puzzleNameRow.add( new UIText( "Puzzle Name" ).setWidth( '90px' ) );
  puzzleNameRow.add( puzzleName );

  settings.add( puzzleNameRow );

  // Puzzle Difficulty

  var puzzleDifficultyRow = new UIRow();
  settings.add( puzzleDifficultyRow );

  puzzleDifficultyRow.add( new UIText( "Difficulty" ).setWidth( '90px' ) );

  var puzzleDifficultySelect = new UISelect().setOptions( {
    0: 'easy',
    1: 'medium',
    2: 'hard'
  } ).setWidth( '120px' ).onChange( updatePuzzleDifficulty );

  function updatePuzzleDifficulty(){
      // Update the diffulty storage here
      var diffs = ["easy", "medium", "hard"];
      console.log("Difficulty change: ", diffs[puzzleDifficultySelect.getValue()]);
      mainPuzzleInfo["difficulty"] = diffs[puzzleDifficultySelect.getValue()];
  }
  puzzleDifficultySelect.setValue( 0 );
  puzzleDifficultyRow.add( puzzleDifficultySelect );

  var tabContainer = new UITabbedPanel();
  tabContainer.setWidth('400px');
  tabContainer.setId("sidebar");
  tabContainer.addTab("Puzzle", "Puzzle Mode", puzzle_mode_container);
  tabContainer.addTab("Pieces", "Pieces Mode", pieces_mode_container);
  tabContainer.addTab("Export", "Export Settings", settings_container);

  tabContainer.select("Puzzle");
  tabContainer.tabs.forEach(uitab => {
      uitab.onClick( function() {
          mainPuzzleInfo["puzzle_pieces_mode"] = tabContainer.selected;
      })
  });
  
  document.body.appendChild(tabContainer.dom);


  // Menubar 

  var menubarContainer = new UIPanel();
	menubarContainer.setId( 'menubar' );

	var menuContainer = new UIPanel();
	menuContainer.setClass( 'menu' );
  menubarContainer.add(menuContainer);

	var title = new UIPanel();
	title.setClass( 'title' );
	title.setTextContent( "File" );
	menuContainer.add( title );

	var options = new UIPanel();
	options.setClass( 'options' );
	menuContainer.add( options );

	// Load Cube File

	var option = new UIRow();
	option.setClass( 'option' );
	option.setTextContent( "Load Cube File" );
	option.onClick( function () {
    document.getElementById('puzzleInput').click();
	});
	options.add( option );

  // Export Cube File
  var exportPuzzleMenu = new UIRow();
  exportPuzzleMenu.setClass( 'option' );
  exportPuzzleMenu.setTextContent( "Export Puzzle" );
  exportPuzzleMenu.onClick( function () {
    // Trigger export
    console.log("Preparing export....");
    var currentDateTimeString = new Date(Date.now()).toLocaleString('fr-CA', 
    {hour: '2-digit', minute: '2-digit', hour12: true, year: "numeric", month: "2-digit", day: "numeric"});
    var mainPuzzleData = {
      meta : {
        name : mainPuzzleInfo['puzzleName'],
        id : uuidv4(), // generate later
        difficulty : mainPuzzleInfo['difficulty'],
        puzzleFormatVersion : "1",
        angle : 0,
        created : currentDateTimeString, // generated time stamp
        author : mainPuzzleInfo['authorName']
      }
    }
    mainPuzzleData['grid'] = seedScene.buildGridData();
    mainPuzzleData['pieces'] = seedScene.buildPiecesData();
    exportToJsonFile(mainPuzzleData);
  });
  options.add(exportPuzzleMenu, new UIHorizontalRule());

  // Custom Puzzles Link
  var customPuzzles = new UIRow();
  customPuzzles.setClass( 'option' );
  customPuzzles.setTextContent( "Shiva's Custom Puzzles" );
  customPuzzles.onClick( function () {
    // Open github link to cutsom puzles
    window.open("https://github.com/shiva-kannan/shiva-kannan.github.io/tree/main/CubismWebLevelEditor/Puzzles", "_blank");
  });
  options.add(customPuzzles);

  // Documentation
  var documentation = new UIRow();
  documentation.setClass( 'option' );
  documentation.setTextContent( "Documentation" );
  documentation.onClick( function () {
    // Open guthub link to documentation
  });
  options.add(documentation);

  // Source code link
  var sourceCode = new UIRow();
  sourceCode.setClass( 'option' );
  sourceCode.setTextContent( "Source Code" );
  sourceCode.onClick( function () {
    // Open guthub link to source code
    window.open("https://github.com/shiva-kannan/shiva-kannan.github.io/tree/main/CubismWebLevelEditor", "_blank");
  });
  options.add(sourceCode);

  document.body.appendChild(menubarContainer.dom);
}

// New Editor UI
setupUIGUI();


// scene
var skyColor = new Color(190, 190, 190);
//seedScene.addNewCube(0,0,0);
const axesHelper = new AxesHelper( 5 );
//axesHelper.material.linewidth = 100;
scene.add( axesHelper );
scene.add(seedScene);

//stats
const stats = Stats();
//document.body.appendChild(stats.dom);


// camera
camera.position.set(6,3,-10);
camera.lookAt(new Vector3(0,0,0));

// renderer
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setClearColor(skyColor, 1);

// render loop
const onAnimationFrameHandler = (timeStamp) => {
  renderer.render(scene, camera);
  seedScene.update && seedScene.update(timeStamp);
  window.requestAnimationFrame(onAnimationFrameHandler);
}
window.requestAnimationFrame(onAnimationFrameHandler);

// resize
const windowResizeHanlder = () => { 
  console.log("resizehandler called");
  const { innerHeight, innerWidth } = window;
  camera.aspect = innerWidth / innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(innerWidth, innerHeight);
  renderer.render(scene, camera);
};
windowResizeHanlder();
window.addEventListener('resize', windowResizeHanlder);

// dom
document.body.style.margin = 0;
document.body.appendChild( renderer.domElement );


// mouse handler
renderer.domElement.addEventListener("mousemove", onMouseMove, false);
renderer.domElement.addEventListener("mousedown", onMouseDown, false);

const raycaster = new Raycaster();
let activeFaceIndex = 0;
var currentHoveredIntersect;
function onMouseMove(event) {
  //console.log("On mouse down intersect");
  raycaster.setFromCamera(
    {
      x: (event.clientX / renderer.domElement.clientWidth) * 2 - 1,
      y: -(event.clientY / renderer.domElement.clientHeight) * 2 + 1
    },
    camera
  );

  const intersects = raycaster.intersectObjects(seedScene.scene_cubes.filter(c => c.visible == true), true);
  //console.log(intersects);
  if (intersects.length > 0) 
  {
    //console.log(intersects[0]);
    if(activeFaceIndex !== -1){
      // Change the previously set color to normal
      seedScene.scene_cubes.forEach(element => {
        element.materials.forEach(mat => {
          mat.color.set(element.cube_color);
        });
      });
    }
    //console.log(intersects[0]);
    activeFaceIndex = intersects[0].face.materialIndex;
    intersects[0].object.material[activeFaceIndex].color.set('black');
    currentHoveredIntersect = intersects[0];
  } 
  else 
  {
    if (activeFaceIndex !== -1)
    {
      seedScene.scene_cubes.forEach(element => {
        element.materials.forEach(mat => {
          mat.color.set(element.cube_color);
        });
      });
    }
    activeFaceIndex = -1;
    currentHoveredIntersect = null;
  }
}

function onMouseDown(event) {
  //console.log("Current Hovered Intersect: ", currentHoveredIntersect);
  if(mainPuzzleInfo["puzzle_pieces_mode"] == "Puzzle"){
    // Get the direction the normal is facing
    // Add a cube to the side of the axis the normal is facing
    if(currentHoveredIntersect){
      // If Hide Mode is on -> hide the cube
      if(puzzleCreationControls['hideMode']){
          currentHoveredIntersect.object.parent.visible = false;
      }
      else{
        // Aligns with X
        if(new Vector3(1,0,0).dot(currentHoveredIntersect.face.normal) !== 0){
          //console.log("Aligns with X axis");
          var alignment = new Vector3(1,0,0).dot(currentHoveredIntersect.face.normal);
          // Add a new cube in the immediate next position from the clicked face
          var currentCubeObject = currentHoveredIntersect.object.parent;
          for(var i=0; i<puzzleCreationControls['extensionLength']; i++){
            seedScene.addNewCube(currentCubeObject.gridx + alignment*(i + 1), currentCubeObject.gridy, currentCubeObject.gridz);
          }
        }
        // Aligns with Y
        if(new Vector3(0,1,0).dot(currentHoveredIntersect.face.normal) !== 0){
          //console.log("Aligns with Y axis");
          var alignment = new Vector3(0,1,0).dot(currentHoveredIntersect.face.normal);
          // Add a new cube in the immediate next position from the clicked face
          var currentCubeObject = currentHoveredIntersect.object.parent;
          for(var i=0; i<puzzleCreationControls['extensionLength']; i++){
            seedScene.addNewCube(currentCubeObject.gridx, currentCubeObject.gridy + alignment*(i + 1), currentCubeObject.gridz);
          }          
        }
        // Aligns with Z
        if(new Vector3(0,0,1).dot(currentHoveredIntersect.face.normal) !== 0){
          //console.log("Aligns with Z axis");
          var alignment = new Vector3(0,0,1).dot(currentHoveredIntersect.face.normal);
          // Add a new cube in the immediate next position from the clicked face
          var currentCubeObject = currentHoveredIntersect.object.parent;
          for(var i=0; i<puzzleCreationControls['extensionLength']; i++){
            seedScene.addNewCube(currentCubeObject.gridx, currentCubeObject.gridy, currentCubeObject.gridz + alignment*(i + 1));
          }
        }
      }
    }
  }
  else if(mainPuzzleInfo["puzzle_pieces_mode"] == "Pieces"){
    // Set the color of the cube to the current selected color
    if(currentHoveredIntersect){
      // If it's in clear color mode :
      if(piecesCreationControls['clearColorMode']){
        var color = currentHoveredIntersect.object.parent.cube_color;
        seedScene.clearPiecesOfColor(color);
      }
      else{
        var currentCubeObject = currentHoveredIntersect.object.parent;
        seedScene.setCubePieceColor(piecesCreationControls['ccolor'], currentCubeObject);
      }
      
    }
  }
}

function onDocumentMouseUp( event ) {

  // Enable the controls
  controls.enabled = true;
  selection = null;
}